module.exports = __webpack_public_path__ + "img/LogoPri936x526.b1b20b40.png";